/* eslint-disable max-lines-per-function */
import React, { useState, useEffect } from "react";
import { cn } from "tailwind-variants";
import { getQueryParams, removeQueryParam } from "common/utils/browser";
import { submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";
import canvaStore from "./canvaStore";
import CanvaModal from "./CanvaModal.vue";
import CanvaPortal from "./CanvaPortal.vue";
import CanvaTrigger from "./CanvaTrigger.vue";

export default function CanvaModule({
  fileLanding,
  namespace,
  replica = false,
  settings = {},
  skipSettingsLoading = false,
  skipInitialModalShow = false,
  onClick,
  ...restProps
}) {
  const AUTO_START_QUERY_PARAM = "open_canva_modal_on_start";
  const store = canvaStore.useStore();
  const [modalRender, setModalRender] = useState(false);
  const triggerId = `canva-button-${namespace}`;

  function handleCanva(skipCanvaModal = false) {
    if (onClick) onClick();
    const args = getQueryParams();
    if (!args[AUTO_START_QUERY_PARAM]) {
      submitDtfEvent("canva_button_click", { namespace });
    }
    const storeSettings = store.getters["canva/settings"];
    if (!storeSettings.authorized) {
      window.location.href = storeSettings.url;
      return;
    }
    setModalRender(true);
    queueMicrotask(() => {
      if (!skipCanvaModal) {
        jQuery(store.getters["canva/$modal"]).modal("show");
      }
      store.dispatch("canva/resetModalState");
    });
  }

  function handleProxy() {
    document.getElementById(triggerId)?.click();
  }

  useEffect(() => {
    store.commit("canva/setSettings", settings);
  }, [settings]);

  useEffect(() => {
    async function mount() {
      if (settings) {
        store.commit("canva/setSettings", settings);
      }
      if (replica) return;
      store.commit("canva/$setFileInput", document.querySelector(fileLanding));
      if (!skipSettingsLoading) {
        await store.dispatch("canva/fetchSettings", namespace);
      }
      // TODO(vue-migration): async callbacks read store getters after await — possible stale closure
      const args = getQueryParams();
      const storeSettings = store.getters["canva/settings"];
      if (args[AUTO_START_QUERY_PARAM] && storeSettings.authorized) {
        handleCanva(skipInitialModalShow);
        removeQueryParam(AUTO_START_QUERY_PARAM);
        submitDtfEvent("canva_account_linked", { namespace });
      }
    }
    mount();
  }, []);

  return (
    <>
      {replica ? (
        <CanvaTrigger
          {...restProps}
          className={cn(`canva-trigger--${namespace}`, restProps.className)}
          onClick={handleProxy}
          data-testid="canva-trigger"
        />
      ) : (
        <>
          <CanvaTrigger
            className={cn(`canva-trigger--${namespace}`)}
            id={triggerId}
            onClick={handleCanva}
            data-testid="canva-trigger-1"
          />

          {modalRender ? (
            <CanvaPortal
              component={CanvaModal}
              props={{
                className: cn(`canva-modal--${namespace}`),
                store
              }}
              data-testid="canva-portal"
            />
          ) : null}
        </>
      )}
    </>
  );
}
